// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountRemovePrescriberDefaultResponse {
    static getAttributeTypeMap() {
        return AccountRemovePrescriberDefaultResponse.attributeTypeMap;
    }
}
AccountRemovePrescriberDefaultResponse.discriminator = undefined;
AccountRemovePrescriberDefaultResponse.additionalProperties = false;
AccountRemovePrescriberDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "boolean"
    },
];
//# sourceMappingURL=accountRemovePrescriberDefaultResponse.js.map